var _style, _g, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217 225",
    style: {
      enableBackground: "new 0 0 217 225"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:none;fill:#F4F7FA;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{opacity:0.66;fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{opacity:0.33;fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 105,
    cy: 110.6,
    r: 99.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.4119,
    y1: 136.6913,
    x2: 178.6703,
    y2: 136.6913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.4,159.5c0,0,103.5,78.2,147.3-66.7c-4.6,6.9-46,69-78.2,57.5c18.4-9.2,41.4-29.9,32.2-52.9 C107.3,136.5,70.5,122.7,31.4,159.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.4544,
    y1: 94.1396,
    x2: 215.5,
    y2: 94.1396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.8,79c4.3,1.2,8.2,2.6,11.7,4c2.1,0.8,4.3,1.8,6.4,2.9c6.3,3.3,10.4,7.1,11.8,11.5 c9.2,23-13.8,43.7-32.2,52.9c32.2,11.5,73.6-50.6,78.2-57.5c9.2-34.5,36.8-36.8,36.8-36.8v-0.1C213.1,52.2,174.9,2.3,102.8,79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.5,
    y1: 154.2211,
    x2: 178.6703,
    y2: 154.2211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M178.7,94.4c-43.7,145-147.3,66.7-147.3,66.7C10.1,183.9,9.7,197.2,1.5,214C36,193.3,174.1,234.8,178.7,94.4 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.1012,
    y1: 71.76,
    x2: 102.7395,
    y2: 71.76
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.7,79C88.4,74.7,72,68.8,54.4,60.6C35.4,51.6,19.3,42,6.1,33v69C33.7,125,85.5,96.2,102.7,79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.1018,
    y1: 119.249,
    x2: 132.652,
    y2: 119.249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M6.1,102c0,0,0,32.2,25.3,57.5c39.1-36.8,75.9-23,101.2-62.1c-2-5-6.7-8.7-11.8-11.5c-1.9-1-4.1-2-6.4-2.9 c-4.6-1.8-9-3.1-11.7-4C85.5,96.2,33.7,125,6.1,102z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar3.3f118f9a5d1d2b1a6d7d397460770e4e.svg";
export { ForwardRef as ReactComponent };